export const AUTH_SESSION = 'AUTH_SESSION';
export const LOGOUT = 'LOGOUT';

export type AuthState = AuthSession;

type AuthAction = {
  type: typeof AUTH_SESSION;
  authSession: Partial<AuthState>;
};

type LogoutAction = {
  type: typeof LOGOUT;
};

export type AuthActions = AuthAction | LogoutAction;
